// extracted by mini-css-extract-plugin
export var cardsCarousel = "CardsCarouselModal-module--cards-carousel--2AvtZ";
export var cardsCarouselSlide = "CardsCarouselModal-module--cards-carousel-slide--3qROu";
export var cardsCarouselSlideSelected = "CardsCarouselModal-module--cards-carousel-slide--selected--1UhuI";
export var cardsCarouselSelected = "CardsCarouselModal-module--cards-carousel-selected--1BqI2";
export var cardsCarouselSelectedWhite = "CardsCarouselModal-module--cards-carousel-selected--white--1GNaf";